module.exports = __webpack_public_path__ + "img/jiaoyu_xianjiaoda_suoluetu.4ba5b7d3.png";